import { inject, observer } from "mobx-react";
import { useParams } from "react-router";

import { RemoteList } from "../../../../core/components/remote/RemoteList.component";
import type { BlockFragment } from "@ihr-radioedit/inferno-webapi";
import { PageBlockInterface } from "../../../../core/page-blocks/Block.component";
import { doPWSSearch } from "@inferno/renderer-shared-core";
import { SearchResults } from "./SearchResults.component";
import { SearchResultsSkeleton } from "./SearchResultsSkeleton.component";
import type { Store } from "@inferno/renderer-shared-core";

interface CoastSearchLoaderProps extends PageBlockInterface {
  block: BlockFragment;
  store?: Store;
  params?: ReturnType<typeof useParams>;
}

export const SearchLoader = inject("store")(
  observer(({ store, isPrimary, params }: CoastSearchLoaderProps) => {
    if (!store || !params?.keyword) {
      return null;
    }

    return (
      <RemoteList
        cursor={doPWSSearch(store.cache)({ keyword: params.keyword })}
        showLoading={isPrimary}
        fallback={<SearchResultsSkeleton />}
      >
        {remote => <SearchResults keyword={params.keyword} {...remote} />}
      </RemoteList>
    );
  }),
);

export default SearchLoader;
